import classNames from 'classnames';
import React from 'react';

import { Icon } from '@sravni/react-design-system';
import { ArrowLeft } from '@sravni/react-icons';
import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

import { LIST } from '../../constants/routes';
import { createLinkProps } from '../../utils/routing';

import styles from './back-link.module.scss';

interface IProps {
  type: PAGE_TYPE;
  customLink?: string;
  customLabel?: string;
}

export const BackLink: React.FC<IProps> = ({ type, customLink, customLabel }) => {
  const listUrl = createLinkProps('/list', LIST, {
    type,
  });

  return (
    <div className={classNames(styles.wrapper, styles['back-link'])}>
      <a href={customLink || listUrl.as} className={styles.link}>
        <Icon icon={<ArrowLeft />} size={16} />
        {customLabel || 'К списку отзывов'}
      </a>
    </div>
  );
};
